module.exports = __webpack_public_path__ + "static/media/close.e689ad5b.svg";